import { render, staticRenderFns } from "./addDetailsContent.vue?vue&type=template&id=c4ec9012&scoped=true&"
import script from "./addDetailsContent.vue?vue&type=script&lang=ts&"
export * from "./addDetailsContent.vue?vue&type=script&lang=ts&"
import style0 from "./addDetailsContent.vue?vue&type=style&index=0&id=c4ec9012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ec9012",
  null
  
)

export default component.exports